import React from 'react';
import { Card, CardSegment } from '../ui';
import ReactMarkdown from 'react-markdown';

const Caption: React.FC<{ caption: string }> = ({ caption }) => {
  return (
    <Card className="tl f7 serif lh-copy mb2">
      <CardSegment className="pv4">
        <ReactMarkdown source={caption} className="markdown-summary" />
      </CardSegment>
    </Card>
  );
};

export default Caption;
